import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import type { AtlassianAccount, GeneratedCJNContent } from './types.tsx';

const GCGS_JIRA_SPOTLIGHT_URL =
	'/gateway/api/gcg/api/v1/generate/team_growth/cross_join_nudge/jira_spotlight';

const ATLASSIAN_ACCOUNT_URL = '/gateway/api/me';

export const generateCJNContent = async (): Promise<GeneratedCJNContent> => {
	try {
		const me = await fetchJson<AtlassianAccount>(ATLASSIAN_ACCOUNT_URL);
		const response = await fetchJson<GeneratedCJNContent>(GCGS_JIRA_SPOTLIGHT_URL, {
			method: 'POST',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				contact_name: me.nickname || me.name,
				domain: me.account_type,
				product: 'confluence',
				job_title: me.extended_profile.job_title,
				department: me.extended_profile.department,
				team_type: me.extended_profile.team_type,
			}),
		});
		return response;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'generateCJNContentFetchFailed',
				packageName: 'jiraCrossJoinNudges',
				teamName: 'groot-growth',
			},
			error,
		});
		throw new Error('Failed to generate nudge content');
	}
};
